<div id="user_footer">
  Powered By <a href="javascript:void(0);" class="footer_logo"><img src="assets/NewJT7/img/footer_logo.png"></a>
</div>
